import { Component, inject, OnInit, signal } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { MessageModule } from "primeng/message";
import { DeeplinkService } from "../../services/deeplink.service";
import { ToastService } from "../../../../common/services/toast.service";


export enum DeeplinkStatus {
  NOT_DONE = 'NOT_DONE',
  DONE = 'DONE',
  FAILED = 'FAILED'
}
@Component({
    selector: 'app-deeplink-conclusion',
    standalone: true,
    imports: [MessageModule],
    templateUrl: './deeplink-conclusion.html',
    providers:[DeeplinkService]
})
export class DeeplinkConclusionComponent implements OnInit {
    private route = inject(ActivatedRoute);
    private router = inject(Router);
    private deeplinkService = inject(DeeplinkService)
    private toastService = inject(ToastService)
    result = signal<string | null>(null);
    courseCode = signal<string | null>(null);
    
    ngOnInit() {
        this.result.set(this.route.snapshot.queryParamMap.get('result'));
        this.courseCode.set(this.route.snapshot.queryParamMap.get('courseCode'));
        if(this.result() && 
           this.courseCode() &&
           this.result()?.trim() !== '' && 
           this.courseCode()?.trim()!==''){
            const resultTransformed = this.result() as string === 'success' ? DeeplinkStatus.DONE:DeeplinkStatus.FAILED
                this.deeplinkService.updateDeeplinkUpdatedDate({
                    courseCode:this.courseCode() as string,
                    result:resultTransformed
                }).then(()=>{
                    if(resultTransformed === DeeplinkStatus.DONE)
                        setTimeout(()=>{
                            this.router.navigate(['/view-lessons']);
                        },3500);
                }).catch(()=>{
                    this.toastService.show({ severity: 'error', summary: 'Error', detail: 'Failed to deeplink, please contact tech support' });
                });
        }else{
            this.toastService.show({ severity: 'error', summary: 'Error', detail: 'Parameters missing!' });
        }
        
    }
}